module.exports = __webpack_public_path__ + "static/media/open-sans-semibold.664e110d.woff";